import { useEffect, useState } from 'react';

export const useCountdown = (seconds: number, onTimeout: () => void, stepMiliseconds: number = 500) => {
    const [targetTime] = useState(new Date().getTime() + seconds * 1000);
    const [remainingSeconds, setSecondsLeft] = useState(seconds);
    const [remainingProgress, setProgress] = useState(100);

    useEffect(() => {
        if (!seconds) {
            return;
        }

        const timer = setInterval(() => {
            const milisecondsRemaining = targetTime - new Date().getTime();
            const secondsRemaining = Math.round(milisecondsRemaining/1000);
            setSecondsLeft(secondsRemaining);
            setProgress((secondsRemaining / seconds) * 100);
    
            if (secondsRemaining <= 0) {
                clearInterval(timer);
                onTimeout();
            }
        }, stepMiliseconds);

        return () => {
            clearInterval(timer);
        };
    }, [seconds, stepMiliseconds, onTimeout, targetTime]);

    return { remainingSeconds, remainingProgress };
};
